<template>
    <div class="tabs">
        <div :class="['tab', activeTab === 'network' ? 'active' : '']" @click="openTab('network')">
            <common-icon name="users" size="semi-small"></common-icon>
            <p>{{ $t('modals.patient_profile.profile.request.tabs.medmatch') }}</p>
        </div>

        <div :class="['tab', activeTab === 'email' ? 'active' : '']" @click="openTab('email')">
            <common-icon name="sms" size="semi-small"></common-icon>
            <p>{{ $t('modals.patient_profile.profile.request.tabs.request') }}</p>
        </div>

        <div :class="['tab', activeTab === 'fax' ? 'active' : '']" @click="openTab('fax')">
            <common-icon name="print" size="semi-small"></common-icon>
            <p>{{ $t('modals.patient_profile.profile.request.tabs.fax') }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            activeTab: { type: String, required: true },
        },

        methods: {
            openTab(name) {
                this.$emit('toggle', name)
            },
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    .tabs {
        display: flex;
        justify-content: space-around;
        margin-bottom: 15px;
        background: #e4e0e0;
        border-radius: 20px;
        overflow: hidden;
    }
    .tab {
        flex: 1;
        text-align: center;
        padding: 5px;
        cursor: pointer;
        color: black;
        font-size: 12px;
        margin: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        gap: 6px;
    }
    .tab.active {
        background: white;
        font-weight: 500;
        border-radius: 32px;
        font-size: 13px;
        color: black;
        font-weight: 500;
    }
    @media screen and (max-width: 600px) {
        .tab,
        .tab.active {
            font-size: 10px;
        }
    }
    .disabled-tab {
        cursor: not-allowed;
        opacity: 0.5;
        pointer-events: none;
    }
</style>
